import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import MediaQuery from "react-responsive";
import Slider from "react-slick";
import "./RecruiterAllReports.css";
import { connect } from "react-redux";

import DashboardBar from "../../../components/Recruiter/DashboardBar/DashboardBar";
import TotalCount from "../../../components/UI/ReportsComponents/TotalCount/TotalCount";
import Dropdown from "../../../components/UI/DropDown/Dropdown";
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";
import axios from "../../../services/axios-service";
import CircleProgressBar from "../../../components/UI/ReportsComponents/CircleProgressBar/CircleProgressBar";
import VerticalProgressBar from "../../../components/UI/ReportsComponents/VerticalProgressBar/VerticalProgressBar";
import MultiVerticalProgressBar from "../../../components/UI/ReportsComponents/MultiVerticalProgressBar/MultiVerticalProgressBar";
import Icon from "../../../components/UI/Icon/Icon";
import Loader from "../../../components/UI/Loader/Loader";
import withErrorHandler from "../../../hoc/withErrorHandler/withErrorHandler";
import config from "../../../config";

/**
 * @desc All Reports section under recruiter Login
 * @version
 * @author Praveen George,Jamshith
 */
const initialJobDetails = {
  completed_count: 0,
  progressed_count: 0,
  regret_experience: 0.0,
  regret_others: 0.0,
  regret_skills: 0.0,
  regretted_count: 0,
  sent_to_client: 0,
  unsorted_count: 0,
  viewed_count: 0,
  progressPercent: 0,
  regretPercent: 0,
  unsortedPercent: 0
};

class RecruiterAllReports extends Component {
  constructor(props) {
    super(props);
    this.state = {
      companyList: [],
      joblist: [],
      activeCompany: "",
      activeJob: "",
      jobDetails: { ...initialJobDetails },
      topProgressedJobs: [],
      loading: true,
      noReports: false
    };
  }

  componentDidMount() {
    this.getCompanyList();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.userDetails !== this.props.userDetails) {
      this.getCompanyList();
    }
  }

  getCompanyList() {
    let appendContent = this.props.userDetails.user_id;
    if (config.reportFilter.includes(this.props.userDetails.user_email)) {
      appendContent = this.props.userDetails.user_id + "&reporting=1";
    }

    axios
      .get("/galaxy/company/job?userId=" + appendContent)
      .then(response => {
        if (response.data.length > 0) {
          const companyList = response.data;
          this.setState({
            companyList,
            activeCompany: companyList[0],
            joblist: companyList[0].jobs ? companyList[0].jobs : [],
            activeJob:
              companyList[0].jobs && companyList[0].jobs[0].jobName
                ? companyList[0].jobs[0]
                : "N/A"
          });
          //ConsoleLog("joblist",companyList[0].jobs)
          if (companyList[0].jobs) {
            this.listJobDetails(companyList[0].jobs[0].jobId);
            this.getTopProgressedJobs(companyList[0].companyId);
          }
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(error => {
        ConsoleLog("error", error);
      });
  }

  handleJobname = (jobName, jobBH) => (
    <Fragment>
      {jobName} <strong>{jobBH}</strong>
    </Fragment>
  );

  handleCompanyChange = (e, item) => {
    e.preventDefault();
    const selectedCompany = this.state.companyList.find(
      company => company.companyId === item
    );
    if (selectedCompany !== this.state.activeCompany) {
      let newJobDetails = { ...this.state.jobDetails };
      newJobDetails.progressPercent = 0;
      newJobDetails.regretPercent = 0;
      newJobDetails.unsortedPercent = 0;
      this.setState({
        joblist: selectedCompany.jobs ? selectedCompany.jobs : [],
        activeCompany: selectedCompany,
        activeJob: selectedCompany.jobs ? selectedCompany.jobs[0] : "N/A",
        jobDetails: { ...newJobDetails }
      });
      if (selectedCompany.jobs) {
        this.listJobDetails(selectedCompany.jobs[0].jobId);
        this.getTopProgressedJobs(selectedCompany.companyId);
      }
      this.getTopProgressedJobs(selectedCompany.companyId);
    }
  };

  handleJobChange = (e, item) => {
    e.preventDefault();
    const selectedJob = this.state.joblist.find(job => job.jobId === item);
    if (selectedJob !== this.state.activeJob) {
      let newJobDetails = { ...this.state.jobDetails };
      newJobDetails.progressPercent = 0;
      newJobDetails.regretPercent = 0;
      newJobDetails.unsortedPercent = 0;
      this.setState({
        activeJob: selectedJob ? selectedJob : "N/A",
        jobDetails: { ...newJobDetails }
      });
      this.listJobDetails(item);
    }
  };

  listJobDetails = jobId => {
    axios
      .get("/galaxy/report/recruiter?jobId=" + jobId)
      .then(response => {
        let newJobDetails = { ...response.data };
        newJobDetails.progressPercent = newJobDetails.progressed_count
          ? Math.floor(
              (newJobDetails.progressed_count / newJobDetails.sent_to_client) *
                100
            )
          : 0;
        newJobDetails.regretPercent = newJobDetails.regretted_count
          ? Math.floor(
              (newJobDetails.regretted_count / newJobDetails.sent_to_client) *
                100
            )
          : 0;
        newJobDetails.unsortedPercent = newJobDetails.unsorted_count
          ? Math.floor(
              (newJobDetails.unsorted_count / newJobDetails.sent_to_client) *
                100
            )
          : 0;
        this.setState({ jobDetails: newJobDetails, loading: false });
      })
      .catch(error => {
        ConsoleLog("error", error);
      });
  };

  getTopProgressedJobs = companyId => {
    axios
      .get("/galaxy/report/recruiter?companyId=" + companyId)
      .then(response => {
        let topProgressedJobs = [...response.data];
        this.setState({ topProgressedJobs });
      })
      .catch(error => {
        ConsoleLog("error", error);
      });
  };
  reportBack = () => {
    ConsoleLog("history", this.props.history);
    this.props.history.push("/recruiter/dashboard");
  };
  handleReportBack = () => {
    this.props.history.push("/recruiter/dashboard");
  };

  render() {
    // ConsoleLog('render report main');
    const companyList = this.state.companyList.map(company => {
      return { value: company.companyId, name: company.companyName };
    });
    const jobList = this.state.joblist.map(job => {
      return {
        value: job.jobId,
        name: (
          <span>
            {job.jobName} <strong>{job.jobBhId}</strong>
          </span>
        )
      };
    });

    const slickSettings = {
      dots: false,
      infinite: false,
      centerMode: true,
      centerPadding: "10px",
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1
    };

    return (
      <div className="rec-reports-container">
        {/* Recruiter reports dashboard bar tab menu starts */}

        {/* Recruiter reports dashboard bar Mobile view starts */}
        <MediaQuery query="(max-device-width: 769px)">
          <div className="rec-reports-back" onClick={this.handleReportBack}>
            <Icon icon="arrow-left" />
            <span className="reports-back-title">Reports</span>
          </div>
        </MediaQuery>
        {/* Recruiter reports dashboard bar Mobile view Ends */}

        {/* Recruiter reports dashboard bar Desktop view starts */}
        <MediaQuery query="(min-device-width: 768px)">
          <DashboardBar activeLink="manage-reports" />
        </MediaQuery>
        {/* Recruiter reports dashboard bar Desktop view Ends */}
        {this.state.loading ? (
          <Loader />
        ) : (
          <Fragment>
            {this.state.companyList.length === 0 ? (
              <div className="no-reports-description">
                <p>No reports to view at this time </p>
              </div>
            ) : (
              <Fragment className="rec-reports">
                <div className="rec-reports-dropdown">
                  <Dropdown
                    className="rec-reports-company-dropdown"
                    activeItem={this.state.activeCompany.companyName}
                    list={companyList}
                    activeId={this.state.activeCompany.companyId}
                    handleItemChange={this.handleCompanyChange}
                  />
                  <Dropdown
                    className={
                      this.state.activeJob !== "N/A"
                        ? "rec-reports-joblist-dropdown"
                        : "rec-reports-joblist-dropdown disable"
                    }
                    activeItem={
                      this.state.activeJob !== "N/A" ? (
                        <Fragment>
                          {this.state.activeJob.jobName}{" "}
                          <strong>{this.state.activeJob.jobBhId}</strong>
                        </Fragment>
                      ) : (
                        "N/A"
                      )
                    }
                    list={jobList}
                    activeId={this.state.activeJob.jobId}
                    handleItemChange={this.handleJobChange}
                  />
                </div>
                {/* Recruiter reports Total count first main row starts */}
                {/* Recruiter reports Total count first main row Mobile view starts */}
                <MediaQuery query="(max-device-width: 767px)">
                  <div className="canditate-total">
                    <div className="row">
                      <Slider {...slickSettings}>
                        <div
                          className={
                            this.state.jobDetails.sent_to_client < 100
                              ? "col-md-4 hide-count-digit"
                              : "col-md-4"
                          }
                        >
                          <TotalCount
                            title={"Total Candidates Sent"}
                            bgcolor={"#24ccb8"}
                            className={"sent-client"}
                            id={"totalSent"}
                            count={
                              this.state.jobDetails.sent_to_client
                                ? this.state.jobDetails.sent_to_client < 100
                                  ? parseInt(
                                      this.state.jobDetails.sent_to_client
                                    ) + 100
                                  : this.state.jobDetails.sent_to_client
                                : 100
                            }
                          />
                        </div>
                        <div
                          className={
                            this.state.jobDetails.viewed_count < 100
                              ? "col-md-4 hide-count-digit"
                              : "col-md-4"
                          }
                        >
                          <TotalCount
                            title={"Total Candidates Viewed"}
                            bgcolor={"#ffc400"}
                            className={"card-item viewed-client"}
                            id={"totalViewed"}
                            count={
                              this.state.jobDetails.viewed_count
                                ? this.state.jobDetails.viewed_count < 100
                                  ? parseInt(
                                      this.state.jobDetails.viewed_count
                                    ) + 100
                                  : this.state.jobDetails.viewed_count
                                : 100
                            }
                          />
                        </div>
                        <div
                          className={
                            this.state.jobDetails.completed_count < 100
                              ? "col-md-4 hide-count-digit"
                              : "col-md-4"
                          }
                        >
                          <TotalCount
                            title={"Total Candidates Completed"}
                            bgcolor={"#3995b4"}
                            className={"card-item completed-client"}
                            id={"totalCompleted"}
                            count={
                              this.state.jobDetails.completed_count
                                ? this.state.jobDetails.completed_count < 100
                                  ? parseInt(
                                      this.state.jobDetails.completed_count
                                    ) + 100
                                  : this.state.jobDetails.completed_count
                                : 100
                            }
                          />
                        </div>
                      </Slider>
                    </div>
                  </div>
                </MediaQuery>
                {/* Recruiter reports Total count first main row Mobile view Ends */}

                {/* Recruiter reports Total count first main row Desktop view starts */}
                <MediaQuery query="(min-device-width: 768px)">
                  <div className="canditate-total">
                    <div className="row">
                      <div
                        className={
                          this.state.jobDetails.sent_to_client < 100
                            ? "col-md-4 hide-count-digit"
                            : "col-md-4"
                        }
                      >
                        <TotalCount
                          title={"Total Candidates Sent"}
                          bgcolor={"#24ccb8"}
                          className={"sent-client"}
                          id={"totalSent"}
                          count={
                            this.state.jobDetails.sent_to_client
                              ? this.state.jobDetails.sent_to_client < 100
                                ? parseInt(
                                    this.state.jobDetails.sent_to_client
                                  ) + 100
                                : this.state.jobDetails.sent_to_client
                              : 100
                          }
                        />
                      </div>
                      <div
                        className={
                          this.state.jobDetails.viewed_count < 100
                            ? "col-md-4 hide-count-digit"
                            : "col-md-4"
                        }
                      >
                        <TotalCount
                          title={"Total Candidates Viewed"}
                          bgcolor={"#ffc400"}
                          className={"card-item viewed-client"}
                          id={"totalViewed"}
                          count={
                            this.state.jobDetails.viewed_count
                              ? this.state.jobDetails.viewed_count < 100
                                ? parseInt(this.state.jobDetails.viewed_count) +
                                  100
                                : this.state.jobDetails.viewed_count
                              : 100
                          }
                        />
                      </div>
                      <div
                        className={
                          this.state.jobDetails.completed_count < 100
                            ? "col-md-4 hide-count-digit"
                            : "col-md-4"
                        }
                      >
                        <TotalCount
                          title={"Total Candidates Completed"}
                          bgcolor={"#3995b4"}
                          className={"card-item completed-client"}
                          id={"totalCompleted"}
                          count={
                            this.state.jobDetails.completed_count
                              ? this.state.jobDetails.completed_count < 100
                                ? parseInt(
                                    this.state.jobDetails.completed_count
                                  ) + 100
                                : this.state.jobDetails.completed_count
                              : 100
                          }
                        />
                      </div>
                    </div>
                  </div>
                </MediaQuery>
                {/* Recruiter reports Total count first main row Desktop view Ends */}
                {/* Recruiter reports Total count first main row ends */}

                {/* Recruiter reports circle progresbar second main row  starts */}
                {/* Recruiter reports circle progreebar second main row Mobile view starts */}
                <MediaQuery query="(max-device-width: 767px)">
                  <div class="canditate-progress">
                    <div class="row">
                      <Slider {...slickSettings}>
                        <div class="col-md-4">
                          <CircleProgressBar
                            className={"prog-candidates"}
                            title={"Progressed Candidates"}
                            strokeDashArray={
                              this.state.jobDetails.progressPercent
                            }
                            stroke={"#caeea4"}
                            strokeColor={"url(#green)"}
                            linearGradientColor={"green"}
                            stopColorStart={"#9ec279"}
                            stopColorEnd={"#caeea4"}
                            processedCount={
                              this.state.jobDetails.progressed_count
                                ? parseInt(
                                    this.state.jobDetails.progressed_count
                                  ) < 100
                                  ? parseInt(
                                      this.state.jobDetails.progressed_count
                                    ) + 100
                                  : parseInt(
                                      this.state.jobDetails.progressed_count
                                    )
                                : 100
                            }
                            totalCount={
                              parseInt(this.state.jobDetails.sent_to_client) <
                              100
                                ? parseInt(
                                    this.state.jobDetails.sent_to_client
                                  ) + 100
                                : parseInt(this.state.jobDetails.sent_to_client)
                            }
                          />
                        </div>
                        <div class="col-md-4">
                          <CircleProgressBar
                            className={"reg-candidates"}
                            title={"Regretted Candidates"}
                            strokeDashArray={
                              this.state.jobDetails.regretPercent
                            }
                            stroke={"#f9868c"}
                            strokeColor={"url(#red)"}
                            linearGradientColor={"red"}
                            stopColorStart={"#c63941"}
                            stopColorEnd={"#f9868c"}
                            processedCount={
                              this.state.jobDetails.regretted_count
                                ? parseInt(
                                    this.state.jobDetails.regretted_count
                                  ) < 100
                                  ? parseInt(
                                      this.state.jobDetails.regretted_count
                                    ) + 100
                                  : parseInt(
                                      this.state.jobDetails.regretted_count
                                    )
                                : 100
                            }
                            totalCount={
                              parseInt(this.state.jobDetails.sent_to_client) <
                              100
                                ? parseInt(
                                    this.state.jobDetails.sent_to_client
                                  ) + 100
                                : parseInt(this.state.jobDetails.sent_to_client)
                            }
                          />
                        </div>
                        <div class="col-md-4">
                          <CircleProgressBar
                            className={"unsort-candidates"}
                            title={"Unsorted Candidates"}
                            strokeDashArray={
                              this.state.jobDetails.unsortedPercent
                            }
                            stroke={"#609eda"}
                            strokeColor={"url(#blue)"}
                            linearGradientColor={"blue"}
                            stopColorStart={"#14385b"}
                            stopColorEnd={"#609eda"}
                            processedCount={
                              this.state.jobDetails.unsorted_count
                                ? parseInt(
                                    this.state.jobDetails.unsorted_count
                                  ) < 100
                                  ? parseInt(
                                      this.state.jobDetails.unsorted_count
                                    ) + 100
                                  : parseInt(
                                      this.state.jobDetails.unsorted_count
                                    )
                                : 100
                            }
                            totalCount={
                              parseInt(this.state.jobDetails.sent_to_client) <
                              100
                                ? parseInt(
                                    this.state.jobDetails.sent_to_client
                                  ) + 100
                                : parseInt(this.state.jobDetails.sent_to_client)
                            }
                          />
                        </div>
                      </Slider>
                    </div>
                  </div>
                </MediaQuery>
                {/* Recruiter reports circle progreebar second main row Mobile view ends */}

                {/* Recruiter reports circle progreebar second main row Desktop view starts */}
                <MediaQuery query="(min-device-width: 768px)">
                  <div class="canditate-progress">
                    <div class="row">
                      <div class="col-md-4">
                        <CircleProgressBar
                          className={"prog-candidates"}
                          title={"Progressed Candidates"}
                          strokeDashArray={
                            this.state.jobDetails.progressPercent
                          }
                          stroke={"#caeea4"}
                          strokeColor={"url(#green)"}
                          linearGradientColor={"green"}
                          stopColorStart={"#9ec279"}
                          stopColorEnd={"#caeea4"}
                          processedCount={
                            this.state.jobDetails.progressed_count
                              ? parseInt(
                                  this.state.jobDetails.progressed_count
                                ) < 100
                                ? parseInt(
                                    this.state.jobDetails.progressed_count
                                  ) + 100
                                : parseInt(
                                    this.state.jobDetails.progressed_count
                                  )
                              : 100
                          }
                          totalCount={
                            parseInt(this.state.jobDetails.sent_to_client) < 100
                              ? parseInt(this.state.jobDetails.sent_to_client) +
                                100
                              : parseInt(this.state.jobDetails.sent_to_client)
                          }
                        />
                      </div>
                      <div class="col-md-4">
                        <CircleProgressBar
                          className={"reg-candidates"}
                          title={"Regretted Candidates"}
                          strokeDashArray={this.state.jobDetails.regretPercent}
                          stroke={"#f9868c"}
                          strokeColor={"url(#red)"}
                          linearGradientColor={"red"}
                          stopColorStart={"#c63941"}
                          stopColorEnd={"#f9868c"}
                          processedCount={
                            this.state.jobDetails.regretted_count
                              ? parseInt(
                                  this.state.jobDetails.regretted_count
                                ) < 100
                                ? parseInt(
                                    this.state.jobDetails.regretted_count
                                  ) + 100
                                : parseInt(
                                    this.state.jobDetails.regretted_count
                                  )
                              : 100
                          }
                          totalCount={
                            parseInt(this.state.jobDetails.sent_to_client) < 100
                              ? parseInt(this.state.jobDetails.sent_to_client) +
                                100
                              : parseInt(this.state.jobDetails.sent_to_client)
                          }
                        />
                      </div>
                      <div class="col-md-4">
                        <CircleProgressBar
                          className={"unsort-candidates"}
                          title={"Unsorted Candidates"}
                          strokeDashArray={
                            this.state.jobDetails.unsortedPercent
                          }
                          stroke={"#609eda"}
                          strokeColor={"url(#blue)"}
                          linearGradientColor={"blue"}
                          stopColorStart={"#14385b"}
                          stopColorEnd={"#609eda"}
                          processedCount={
                            this.state.jobDetails.unsorted_count
                              ? parseInt(this.state.jobDetails.unsorted_count) <
                                100
                                ? parseInt(
                                    this.state.jobDetails.unsorted_count
                                  ) + 100
                                : parseInt(this.state.jobDetails.unsorted_count)
                              : 100
                          }
                          totalCount={
                            parseInt(this.state.jobDetails.sent_to_client) < 100
                              ? parseInt(this.state.jobDetails.sent_to_client) +
                                100
                              : parseInt(this.state.jobDetails.sent_to_client)
                          }
                        />
                      </div>
                    </div>
                  </div>
                </MediaQuery>
                {/* Recruiter reports circle progreebar second main row Desktop view ends */}
                {/* Recruiter reports circle progreebar second main row ends */}

                <MediaQuery query="(max-device-width: 767px)">
                  <div className="canditate-rejection-feedback card-item">
                    <div className="rejection-reasons">
                      <h6>Rejection Reasons</h6>
                      <div className="vertical-progress">
                        <VerticalProgressBar
                          className={"vertical-progress-item"}
                          rejectionReason={
                            "Does not meet expectation of skills"
                          }
                          rejectionReasonClass={"skills"}
                          percentage={Math.round(
                            this.state.jobDetails.regret_skills
                          )}
                        />
                        <VerticalProgressBar
                          className={"vertical-progress-item"}
                          rejectionReason={
                            "Does not meet expectation of experience"
                          }
                          rejectionReasonClass={"exp"}
                          percentage={Math.round(
                            this.state.jobDetails.regret_experience
                          )}
                        />
                        <VerticalProgressBar
                          className={"vertical-progress-item"}
                          rejectionReason={"Others"}
                          rejectionReasonClass={"others"}
                          percentage={Math.round(
                            this.state.jobDetails.regret_others
                          )}
                        />
                      </div>
                    </div>
                  </div>
                  {/* Recruiter reports vertical ProgressBar third main row first section ends */}

                  {/* Recruiter reports Multi-vertical ProgressBar third main row first section starts */}
                  <div className="top-progressed-jobs card-item">
                    <div className="progressed-categories">
                      <h6>Top Progressed Jobs</h6>
                      <span className="greenSquare">Progress</span>
                      <span className="redSquare">Regret</span>
                      <span className="blueSquare">Unsorted</span>
                    </div>
                    {this.state.topProgressedJobs.length > 0
                      ? this.state.topProgressedJobs.map((job, index) => (
                          <MultiVerticalProgressBar
                            jobTitle={job.job_name}
                            greenPercentage={job.progressed_count}
                            redPercentage={job.regretted_count}
                            bluePercentage={job.unsorted_count}
                          />
                        ))
                      : null}
                    {Array(4 - this.state.topProgressedJobs.length)
                      .fill(null)
                      .map(() => (
                        <MultiVerticalProgressBar greenPercentage={null} />
                      ))}
                  </div>
                  {/* Recruiter reports Multi-vertical ProgressBar third main row first section ends */}
                </MediaQuery>

                <MediaQuery query="(min-device-width: 768px)">
                  <div className="canditate-rejection-feedback">
                    <div className="row">
                      {/* Recruiter reports vertical ProgressBar third main row first section starts */}
                      <div className="col-md-8">
                        <div className="card-item">
                          <div className="rejection-reasons">
                            <h6>Rejection Reasons</h6>
                            <div className="row vertical-progress-first">
                              <VerticalProgressBar
                                className={"reject-first"}
                                rejectionReason={
                                  "Does not meet expectation of skills"
                                }
                                rejectionReasonClass={"skills"}
                                percentage={Math.round(
                                  this.state.jobDetails.regret_skills
                                )}
                              />
                              <VerticalProgressBar
                                className={"reject-second"}
                                rejectionReason={
                                  "Does not meet expectation of experience"
                                }
                                rejectionReasonClass={"exp"}
                                percentage={Math.round(
                                  this.state.jobDetails.regret_experience
                                )}
                              />
                            </div>
                            <div className="row vertical-progress-second">
                              <VerticalProgressBar
                                className={"reject-third"}
                                rejectionReason={"Others"}
                                rejectionReasonClass={"others"}
                                percentage={Math.round(
                                  this.state.jobDetails.regret_others
                                )}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Recruiter reports vertical ProgressBar third main row first section ends */}

                      {/* Recruiter reports Multi-vertical ProgressBar third main row first section starts */}
                      <div className="col-md-4">
                        <div className="card-item top-progressed-jobs">
                          <div className="progressed-categories">
                            <h6>Top Progressed Jobs</h6>
                            <span className="greenSquare">Progress</span>
                            <span className="redSquare">Regret</span>
                            <span className="blueSquare">Unsorted</span>
                          </div>
                          {this.state.topProgressedJobs.length > 0
                            ? this.state.topProgressedJobs.map((job, index) => (
                                <MultiVerticalProgressBar
                                  jobTitle={job.job_name}
                                  greenPercentage={job.progressed_count}
                                  redPercentage={job.regretted_count}
                                  bluePercentage={job.unsorted_count}
                                />
                              ))
                            : null}
                          {Array(4 - this.state.topProgressedJobs.length)
                            .fill(null)
                            .map(() => (
                              <MultiVerticalProgressBar
                                greenPercentage={null}
                              />
                            ))}
                        </div>
                      </div>
                      {/* Recruiter reports Multi-vertical ProgressBar third main row first section ends */}
                    </div>
                  </div>
                </MediaQuery>
              </Fragment>
            )}
          </Fragment>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  userDetails: state.clientProfile.clientDetails
});

export default connect(mapStateToProps)(
  withErrorHandler(RecruiterAllReports, axios)
);



// WEBPACK FOOTER //
// ./src/container/Recruiter/RecruiterAllReports/RecruiterAllReports.js